import React from 'react';

interface LineInfoIconProps {
  size?: number;
  color?: string;
}

export const LineInfoIcon: React.FC<LineInfoIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M10.8779 13.3812C10.8928 11.5352 11.4542 11.4098 12.3474 10.859C12.9875 10.4421 13.4787 9.98067 13.4787 9.2959C13.4787 8.55158 12.8982 8.06032 12.1836 8.06032C11.802 8.06032 11.4381 8.19762 11.1813 8.46497C10.7842 8.87833 10.3595 9.4001 9.78628 9.4001C9.19022 9.4001 8.69186 8.89982 8.86765 8.33028C9.31894 6.86819 10.6271 6 12.1836 6C14.2528 6 15.7415 7.39044 15.7415 9.22146C15.7415 10.4421 15.1162 11.2311 14.1337 11.8117C13.3001 12.3178 12.9279 12.4181 12.913 13.4602C12.913 13.7583 12.6714 14 12.3732 14H11.5709C11.2161 14 10.9178 13.7337 10.8779 13.3812Z"
        fill={color}
      />
      <circle cx="12" cy="16.25" r="1.25" fill={color} />
    </svg>
  );
};
